import React from 'react'
import TopHeader from '../../layout/TopHeader'
import MainHeader from '../../layout/MainHeader'
import Footer from '../../layout/Footer'
import Jotform from 'react-jotform'
import MainResHeader from '../../layout/MainResHeader'
import { useEffect } from 'react'
import { Helmet, HelmetProvider } from 'react-helmet-async'


const BloodTestForm = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])
  return (
    <div style={{ overflow:'hidden'}}>
    <HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>General Blood Test Appointment | United Lab Care</title>
      <meta name="description" content="Book your appointment at 43 Roosevelt Rd, Villa Park, IL (Near Roosevelt Rd and Ardmore Ave, Adjacent to Aldi)." />
	<link rel="canonical" href="https://unitedlabcare.com/general-blood-test-appointment/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="General Blood Test Appointment | United Lab Care" />
	<meta property="og:description" content="Book your appointment at 43 Roosevelt Rd, Villa Park, IL (Near Roosevelt Rd and Ardmore Ave, Adjacent to Aldi)." />
	<meta property="og:url" content="https://unitedlabcare.com/general-blood-test-appointment/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-06-16T17:26:59+00:00" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="3 minutes" />
      </Helmet>
    </HelmetProvider>
    <TopHeader/>
    {/* <MainHeader/> */}
    <MainResHeader/>
    
    <div className='mb-md-4'>
        <Jotform src='https://form.jotform.com/231654253411448' 
          defaults={{
                      name: ''
                    }}
        />
    </div>

    <Footer/>
    </div>
  )
}

export default BloodTestForm